import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const UserInviteContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "UserInviteContainer" */
      './UserInviteContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
